import { executeServerJob } from "./executor.js";
import { JOB_DONE_EVENT_PREFIX } from "../../types/events/jobDone.js";
import { jobDelay } from "../job/delay.js";
/**
 * Memorize all executed server jobs to avoid multiple executions.
 * Why: We have created a task for each job, but on server side we
 * are executing jobs iteratively until max execution time exceeded.
 *
 * Simply said: One network request could potentially execute
 * multiple jobs.
 */ const SUCCESSFUL_SERVER_JOBS = [];
/**
 * Convert a server job to promise.
 *
 * @param tryIds All the Job IDs which should be also be tried with this single request
 */ function convertServerJobToPromise(queue, job, tryIds) {
    const { id, type } = job;
    const fn = async ()=>{
        const dispatchDoneEvent = (success)=>document.dispatchEvent(new CustomEvent(`${JOB_DONE_EVENT_PREFIX}${type}`, {
                detail: {
                    job,
                    success
                }
            }));
        if (SUCCESSFUL_SERVER_JOBS.indexOf(id) > -1) {
            // Job already executed, skip this!
            dispatchDoneEvent(true);
            return;
        }
        try {
            const { done } = await executeServerJob(job, tryIds);
            SUCCESSFUL_SERVER_JOBS.push(...done.map(({ id })=>id));
            dispatchDoneEvent(SUCCESSFUL_SERVER_JOBS.indexOf(id) > -1);
        } catch (e) {
            // Something went wrong between request and WP REST API - we pause the queue here cause
            // we wait for the next refresh of the page - the REST API response is always valid and
            // does not throw any error
            queue.handler.pause();
        }
    };
    const delay = ()=>SUCCESSFUL_SERVER_JOBS.indexOf(id) > -1 ? Promise.resolve() : jobDelay(job);
    return [
        fn,
        delay
    ];
}
export { convertServerJobToPromise };
